<template>
  <ConfirmDialog class="bravado-global-confirm" :name="name" @before-close="handleCancel">
    <template v-if="title" slot="title">
      {{ title }}
    </template>
    <BravadoText v-if="hint" variant="body" class="bravado-global-confirm__hint">
      {{ hint }}
    </BravadoText>
    <template slot="actions">
      <BravadoButtonV3 variant="secondary" @click="handleCancel">Cancel</BravadoButtonV3>
      <BravadoButtonV3 :variant="variant" @click="handleAction">{{ action }}</BravadoButtonV3>
    </template>
  </ConfirmDialog>
</template>

<script lang="ts">
import Vue from 'vue';
import { events } from './utils';
import { OPEN_CONFIRM_EVENT, CLOSE_CONFIRM_EVENT } from './constants';
import type { ConfirmPayload } from './types';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import ConfirmDialog from '~/components/common/ConfirmDialog.vue';

const DEFAULT_ACTION_NAME = 'Remove';

export default Vue.extend({
  name: 'Confirm',
  components: {
    ConfirmDialog,
    BravadoButtonV3,
  },
  data(): ConfirmPayload & { name: string } {
    return {
      name: 'confirm',
      variant: 'danger',
      action: DEFAULT_ACTION_NAME,
      title: null,
      hint: null,
      resolve: undefined,
      reject: undefined,
    };
  },
  beforeMount() {
    events.$on(OPEN_CONFIRM_EVENT, this.open);
    events.$on(CLOSE_CONFIRM_EVENT, this.close);
  },
  beforeDestroy() {
    events.$off(OPEN_CONFIRM_EVENT, this.open);
    events.$off(CLOSE_CONFIRM_EVENT, this.close);
  },
  methods: {
    open({
      action = DEFAULT_ACTION_NAME,
      title = null,
      hint = null,
      variant = 'danger',
      resolve,
      reject,
    }: ConfirmPayload) {
      this.action = action;
      this.title = title;
      this.hint = hint;
      this.variant = variant;

      this.$nextTick(() => {
        this.$modal.show(this.name);
      });

      this.resolve = resolve;
      this.reject = reject;
    },
    close() {
      this.$modal.hide(this.name);
    },
    handleAction() {
      this.resolve && this.resolve();
      this.close();
    },
    handleCancel() {
      this.reject && this.reject(new Error('Action has been cancelled'));
      this.close();
    },
  },
});
</script>

<style lang="scss" scoped>
.bravado-global-confirm {
  &__hint {
    color: var(--theme-color-text);
    opacity: 0.6;
  }
}
</style>
